module.exports = __webpack_public_path__ + "img/homeTag-icon-7.33b39f92.svg";